import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { fmt } from "../../lib/api";
import SectionCard from "./SectionCard";
import {
  Select, SelectTrigger, SelectContent, SelectItem, SelectValue,
} from "../ui/select";

export default function Kategori3({ factors, data, setData, results }) {
  const setNum = (group, id, v) => setData((d) => ({ ...d, [group]: { ...(d[group] || {}), [id]: v } }));
  const setVal = (k, v) => setData((d) => ({ ...d, [k]: v }));

  return (
    <div className="space-y-6 animate-fadeInUp">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-1">Kategori 3</div>
        <h2 className="font-display text-3xl font-semibold">Ulaştırma & Konaklama</h2>
        <p className="text-muted-foreground mt-1 text-sm max-w-2xl">
          Çalışan servisleri, ürün taşımacılığı, iş seyahatleri ve misafir konaklamalarından kaynaklanan emisyonlar.
        </p>
      </div>

      <SectionCard title="Çalışan Ulaşımı / Servis" total={results?.calisan_total}>
        <TableHeader />
        {factors.calisan.map((f) => (
          <Row key={f.id} factor={f}
               value={data.calisan?.[f.id] || ""}
               onChange={(v) => setNum("calisan", f.id, v)}
               result={results?.calisan?.find((x) => x.key === f.id)?.total} />
        ))}
      </SectionCard>

      <SectionCard title="Hammadde / Ürün Taşınımı" total={results?.tasinim_total}>
        <TableHeader />
        {factors.tasinim.map((f) => (
          <Row key={f.id} factor={f}
               value={data.tasinim?.[f.id] || ""}
               onChange={(v) => setNum("tasinim", f.id, v)}
               result={results?.tasinim?.find((x) => x.key === f.id)?.total} />
        ))}
      </SectionCard>

      <SectionCard title="İş Seyahatleri" total={results?.seyahat_total}>
        <TableHeader />
        {factors.is_seyahati.map((f) => (
          <Row key={f.id} factor={f}
               value={data.is_seyahati?.[f.id] || ""}
               onChange={(v) => setNum("is_seyahati", f.id, v)}
               result={results?.is_seyahati?.find((x) => x.key === f.id)?.total} />
        ))}
      </SectionCard>

      <SectionCard title="Misafir Konaklaması" total={results?.konaklama?.total}>
        <div className="grid md:grid-cols-3 gap-4">
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Ülke</Label>
            <Select value={data.konaklama_ulke} onValueChange={(v) => setVal("konaklama_ulke", v)}>
              <SelectTrigger data-testid="k3-konak-ulke"><SelectValue /></SelectTrigger>
              <SelectContent>
                {factors.konaklama.map((k) => (
                  <SelectItem key={k.id} value={k.id}>
                    {k.label} ({fmt(k.ef, 1)} kg/oda/gece)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Toplam Oda/Gece</Label>
            <Input type="number" step="any" value={data.konaklama_fv || ""}
                   onChange={(e) => setVal("konaklama_fv", e.target.value)}
                   placeholder="Ör: 1324" data-testid="k3-konak-fv" />
          </div>
          {data.konaklama_ulke === "konak_diger" && (
            <div>
              <Label className="text-sm font-medium mb-1.5 block">Özel EF (kg CO₂e/oda)</Label>
              <Input type="number" step="any" value={data.konaklama_custom_ef || ""}
                     onChange={(e) => setVal("konaklama_custom_ef", e.target.value)} />
            </div>
          )}
        </div>
        <div className="text-xs text-muted-foreground mt-4">
          Emisyon: <strong className="text-foreground">{fmt(results?.konaklama?.total || 0, 3)} tCO₂e</strong>
        </div>
      </SectionCard>
    </div>
  );
}

function TableHeader() {
  return (
    <div className="grid grid-cols-12 gap-2 text-[11px] uppercase tracking-wider text-muted-foreground px-1 pb-2">
      <div className="col-span-6">Kaynak</div>
      <div className="col-span-2">Faaliyet Verisi</div>
      <div className="col-span-2 text-center">EF (kg/birim)</div>
      <div className="col-span-2 text-right">tCO₂e</div>
    </div>
  );
}

function Row({ factor, value, onChange, result }) {
  return (
    <div className="grid grid-cols-12 gap-2 items-center py-1.5 border-t border-border/50">
      <div className="col-span-6">
        <div className="font-medium text-sm">{factor.label}</div>
        <div className="text-[11px] text-muted-foreground truncate">{factor.kaynak}</div>
      </div>
      <div className="col-span-2">
        <Input type="number" step="any" value={value} onChange={(e) => onChange(e.target.value)}
               placeholder={`0 ${factor.unit}`} className="h-9" data-testid={`input-${factor.id}`} />
      </div>
      <div className="col-span-2 text-xs text-muted-foreground text-center tabular-nums">{fmt(factor.ef, 5)}</div>
      <div className="col-span-2 text-right text-sm font-medium tabular-nums">
        {(result || 0) > 0 ? fmt(result, 3) : "—"}
      </div>
    </div>
  );
}
